export class MultiServiceBoost {
    readonly serviceCode: string;
    readonly coeffOfConsideration: number;
    readonly minCaOfConsideration: number;
    readonly isImpacted: boolean;
    readonly minCaForImpact: number;

    constructor(serviceCode: string, coeffOfConsideration: number, minCaOfConsideration: number, isImpacted: boolean, minCaForImpact: number) {
        this.serviceCode = serviceCode;
        this.coeffOfConsideration = coeffOfConsideration;
        this.minCaOfConsideration = minCaOfConsideration;
        this.isImpacted = isImpacted;
        this.minCaForImpact = minCaForImpact;
    }

    getCoeffOfConsideration(quoteServiceMonthlyAmount: number): number {
        return quoteServiceMonthlyAmount >= this.minCaOfConsideration ? this.coeffOfConsideration : 0;
    }
}